export function isClientError(status: number) {
  return status >= 400 && status < 500;
}

export function isServerError(status: number) {
  return status >= 500 && status < 600;
}

export function isError(status: number) {
  return isClientError(status) || isServerError(status);
}
